export const STATUSES = {
  1: {
    title: 'Pending',
  },
  2: {
    title: 'Awaiting',
  },
  4: {
    title: 'Rejected',
  },
  3: {
    title: 'In progress',
  },
  7: {
    title: 'Completed',
  },
}
